
import {YIBF_EXCEL_UPLOAD} from '../constants/requestUrls';
import { postFileRequest } from "../request";

const YibfExcelUploadForm = (data) => {
    return postFileRequest({ url: YIBF_EXCEL_UPLOAD, data });
}

export default YibfExcelUploadForm;